import RequestApi from "../../modules/requestApi";

const state = {
  // список тарифов
  tariffList: [],
  // признак что список заружен
  tariffIsLoaded: false
};

const mutations = {
  // список хотспотов
  SET_TARIFF_LIST(state, data) {
    // сортируем по цене
    state.tariffList = data.sort((a, b) =>
      a.abonpay > b.abonpay ? 1 : b.abonpay > a.abonpay ? -1 : 0
    );
  },
  //признак что список загружен
  SET_TARIFF_IS_LOADED(state, data) {
    state.tariffIsLoaded = data;
  }
};

const actions = {
  // загрузка данных по списку тем
  tariffListLoad({ commit, state }) {
    if (!state.tariffIsLoaded) {
      return new Promise((resolve, reject) => {
        RequestApi.getTariffs()
          .then(data => {
            const tariffs = [];
            let smsCount = {};
            // перебираем тарифы
            for (var i = 0; i < data.tariffs.length; i++) {
              // если функция dop входит в группу 36, то это к-во смс
              if (data.tariffs[i].dop) {
                smsCount = data.tariffs[i].dop.find(
                  item => item.group_id === "36"
                );
              }
              // убираем из допов пустые и СМС
              data.tariffs[i].dop = data.tariffs[i].dop.filter(
                item => item.group_id !== "36" && item.id !== ""
              );
              tariffs.push({
                id: data.tariffs[i].tarif_id,
                name: data.tariffs[i].tarif_name,
                price: data.tariffs[i].abonpay,
                smsCount: smsCount ? smsCount.count_elements + " СМС" : "",
                priceMoreCount: smsCount ? smsCount.price_more_count : "",
                abonpay: parseInt(data.tariffs[i].abonpay),
                functions: data.tariffs[i].dop.sort((a, b) =>
                  a.abonpay > b.abonpay ? 1 : b.abonpay > a.abonpay ? -1 : 0
                )
              });
            }
            commit("SET_TARIFF_LIST", tariffs);
            commit("SET_THEME_IS_LOADED", true);
          })
          .catch(reject);
      });
    }
  }
};

const getters = {
  // список тем
  tariffList: state => {
    return state.tariffList;
  },
  // признак загрузки списка
  tariffIsLoaded: state => {
    return state.tariffIsLoaded;
  },
  // объект с tariff по id
  getTariffs: state => id => {
    return state.tariffList.find(item => item.id === id);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
